import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Member from './pages/Member';
import './App.css';
import { useEffect, useState } from 'react';
import MainPage from './pages/MainPage';
import AddEmergency from './pages/AddEmergency';
import Cars from './pages/Cars';
import Settings from './pages/Settings';
import Footer from './pages/Footer';
import Suits from './pages/Suits';
import EditSuits from './pages/EditSuit';
import SignIn from './pages/SignIn';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ForgetPasswordPage from './pages/ForgetPasswordPage';
import TestTimePage from './pages/TestTimePage';

function App() {
  const [loggedState, setLoggedState] = useState<number>(0);
  const [loggedName, setLoggedName] = useState<String>("");
  const [loggedID, setLoggedID] = useState<String>("");
  const [agbStatus, setAGBStatus] = useState<number>(0);
  const [dsgvoStatus, setDSGVOStatus] = useState<number>(0);
  const [useCondStatus, setUseCondStatus] = useState<number>(0);
  const [suitID, setSuitID] = useState<number>(0);
  const [suitName, setSuitName] = useState<string>("");
  document.title = "RescueOfficer";

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login setLoggedState={setLoggedState} setLoggedName={setLoggedName} setLoggedID={setLoggedID} setAGBStatus={setAGBStatus} setDSGVOStatus={setDSGVOStatus} setUseCondStatus={setUseCondStatus} />} />
          <Route path="/MainPage" element={<MainPage loggedState={loggedState} setLoggedState={setLoggedState} loggedName={loggedName} setLoggedName={setLoggedName} loggedID={loggedID} setLoggedID={setLoggedID} agbStatus={agbStatus} dsgvoStatus={dsgvoStatus} useCondStatus={useCondStatus}/>} />
          <Route path="/Member" element={<Member loggedState={loggedState} loggedID={loggedID}/>} />
          <Route path="/Cars" element={<Cars loggedState={loggedState} loggedID={loggedID}/>} />
          <Route path="/Suits" element={<Suits loggedState={loggedState} loggedID={loggedID} setSuitID={setSuitID} setSuitName={setSuitName}/>} />
          <Route path="/EditSuit" element={<EditSuits loggedState={loggedState} suitID={suitID} suitName={suitName} loggedID={loggedID}/>} />
          <Route path="/AddEmergency" element={<AddEmergency loggedState={loggedState} emID={-1} loggedID={loggedID}/>} />
          <Route path="/Settings" element={<Settings loggedState={loggedState} loggedID={loggedID}/>} />
          <Route path="/ChangePassword" element={<ChangePasswordPage login={loggedName}/>} />
          <Route path="/SignIn" element={<SignIn />} />
          <Route path="/ForgetPassword" element={<ForgetPasswordPage />} />
          <Route path="/TestTime" element={<TestTimePage />} />
        </Routes>
      </Router>
      <Footer></Footer>
    </div>
  );
}

export default App;
